// extracted by mini-css-extract-plugin
module.exports = {"progressIcon":"ProgressIcon_progressIcon__AWZdu","icon":"ProgressIcon_icon__sW186"};